// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__3uJxd","button-wrapper":"error_button-wrapper__1wGR7"};